import React from 'react';

// REACT ROUTER
import { useHistory } from 'react-router-dom';

// MATERIAL UI
import {
  AppBar,
  Button,
  Divider, 
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  SwipeableDrawer,
  Toolbar,
  Typography
} from '@material-ui/core';

// MATERIAL ICONS
import MenuIcon from '@material-ui/icons/Menu';
import AssessmentIcon from '@material-ui/icons/Assessment';
// import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import PersonIcon from '@material-ui/icons/Person';
import AccessibilityIcon from '@material-ui/icons/Accessibility';
// import CategoryIcon from '@material-ui/icons/Category';
// import ListAltIcon from '@material-ui/icons/ListAlt';

import clsx from 'clsx';


const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
});

const menuItems = [
  {
    id: 1,
    title: 'Inicio',
    icon: <AssessmentIcon/>,
    route: '/dashboard',
    hidden: false
  },
  {
    id: 2,
    title: 'Facturas',
    icon: <AccessibilityIcon/>,
    route: '/dashboard/invoices',
    hidden: false
  },
  // {
  //   id: 3,
  //   title: 'Buscar Productos',
  //   icon: <Search/>,
  //   route: '/dashboard/searchProduct',
  //   hidden: false
  // },
  // {
  //   id: 4,
  //   title: 'Marcas',
  //   icon: <ListAltIcon/>,
  //   route: '/dashboard/brands',
  //   hidden: false
  // },
  // {
  //   id: 5,
  //   title: 'Categorías',
  //   icon: <CategoryIcon/>,
  //   route: '/dashboard/categories',
  //   hidden: false
  // },
  // {
  //   id: 6,
  //   title: 'Ventas',
  //   icon: <MonetizationOnIcon/>,
  //   route: '/dashboard/sales',
  //   hidden: false
  // },
  {
    id: 4,
    title: 'Administrar cuentas',
    icon: <PersonIcon/>,
    route: '/dashboard/accounts'
  },
];
export default function SwipeableTemporaryDrawer() {

  const history = useHistory ();
  const classes = useStyles();
  
  const [drawable, setDrawable] = React.useState({
    left: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setDrawable({ ...drawable, [anchor]: open });
  };

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === 'top' || anchor === 'bottom',
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <Divider />
      <List>
        {menuItems.map((item, index) => (
          <ListItem button key={item.id} onClick={() => history.push(item.route)}>
              <ListItemIcon key={item.route}>{item?.icon}</ListItemIcon>
              <ListItemText key={item.title} primary={item.title} />
          </ListItem>
        ))}
      </List>
    </div>
  );
  // PROFILE MENU 
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };
  
  // const { state, setCurrentProject } = useContext(AppContext)
  // useEffect(()=> {
  //   if(!state?.customerProjectSelected) {
  //     setCurrentProject(state?.customerProjectList[0]);
  //   }
  // },[])

  return (
    <div>
      {
        ['left'].map((anchor) => (
          <React.Fragment key={anchor}>
            <AppBar position="static">
              <Toolbar>
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%'}}>
                    <IconButton onClick={toggleDrawer(anchor, true) } edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
                      <MenuIcon />
                    </IconButton>
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%', justifyContent: 'start'}}>
                      <Typography variant="h6">
                        Lasir (v0.0.1)
                      </Typography>
                      <div style={{ marginLeft: 'auto', padding: '0.5em' }}>
                        {/* {JSON.stringify(state?.customerProjectList, null, 3)} */}
                        {/* <Autocomplete
                          id="projectsList"
                          options={state?.customerProjectList}
                          getOptionLabel={(option) => option.customer_name}
                          defaultValue={state?.customerProjectSelected}
                          onChange={(event, value) => setCurrentProject(value)}
                          style={{ width: 300, backgroundColor: 'white' }} // Cambiar el fondo a blanco
                          renderInput={(params) => <TextField {...params} label="Selecciona la empresa" variant="outlined" />}
                        /> */}
                      </div>
                    <Button 
                        aria-controls="simple-menu" 
                        aria-haspopup="true" 
                        onClick={handleClick}
                      >
                        {/* {
                          currentUser && <Typography style={{ color: 'white' }}>
                          {currentUser?.givenNames} {currentUser?.lastName}
                        </Typography>                    
                        } */}
                      </Button>
                      {/* <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                        
                      >
                        <div style={{minWidth: '250px'}} >
                          <div style={{ display: 'flex', justifyContent: 'center', minHeight: '4em', alignItems: 'center', flexDirection: 'column' }}>
                            {
                              currentUser?.givenNames && <Avatar>
                                {currentUser?.givenNames?.slice(0,1)}{currentUser?.lastName.slice(0,1)}
                              </Avatar>
                            }
                            
                          </div>
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                              <span style={{paddingLeft: '1em', marginBottom: '0.5em' }}>
                                Bienvenido: {currentUser?.givenNames} {currentUser?.lastName}
                              </span>
                              <span style={{paddingLeft: '1em', marginBottom: '0.5em' }}>
                                Rol: {currentUser?.role}
                              </span>
                          </div>
                            
                        <Divider/>
                        <MenuItem onClick={handleClose}>My account</MenuItem>
                        <Divider/>
                        <MenuItem onClick={() => {
                          logout();
                          handleClose();
                        }}>
                          <ExitToAppIcon/>
                          <span style={{marginLeft: '0.5em'}}>Logout</span></MenuItem>
                        </div>
                      </Menu> */}

                    </div>
                </div>
              </Toolbar>
            </AppBar>
            {/* <Button onClick={toggleDrawer(anchor, true)}>{anchor}</Button> */}
            <SwipeableDrawer
              anchor={anchor}
              open={drawable[anchor]}
              onClose={toggleDrawer(anchor, false)}
              onOpen={toggleDrawer(anchor, true)}
            >
              {list(anchor)}
            </SwipeableDrawer>
          </React.Fragment>
        ))
      }
    </div>
  );
}
